import { faSparkles } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useEffect, useState, memo, useCallback } from 'react';
import JustificationSuggestionsContainer from 'react-scale/components/scalers/tasks/ThreadedInteraction/ResponseSuggestions/components/JustificationSuggestionsContainer';
import { twMerge } from 'tailwind-merge';

interface SuggestionsMarkProps {
  minValue: number;
  maxValue: number;
  selectedValue?: number;
  className?: string;
  loading?: boolean;
}

const SuggestionsMark: React.FC<SuggestionsMarkProps> = ({
  minValue,
  maxValue,
  selectedValue = 0,
  className,
  loading,
}) => {
  const [arrowPosition, setArrowPosition] = useState<number>(0);
  const [cardPosition, setCardPosition] = useState<number>(0);
  const [containerRef, setContainerRef] = useState<HTMLDivElement | null>(null);
  const [cardRef, setCardRef] = useState<HTMLDivElement | null>(null);

  const calculatePositions = useCallback(() => {
    if (containerRef && cardRef) {
      const containerWidth = containerRef.offsetWidth;
      const cardWidth = cardRef.offsetWidth;

      const totalButtons = maxValue - minValue + 1;
      const buttonWidth = containerWidth / totalButtons;

      const newArrowPosition = buttonWidth * (selectedValue - minValue + 0.5);
      setArrowPosition(newArrowPosition);

      let newCardPosition = newArrowPosition;

      const halfCardWidth = cardWidth / 2;
      if (newCardPosition < halfCardWidth) {
        newCardPosition = halfCardWidth;
      } else if (newCardPosition > containerWidth - halfCardWidth) {
        newCardPosition = containerWidth - halfCardWidth;
      }

      setCardPosition(newCardPosition);
    }
  }, [cardRef, containerRef, maxValue, minValue, selectedValue]);

  useEffect(() => {
    calculatePositions();

    window.addEventListener('resize', calculatePositions);
    return () => window.removeEventListener('resize', calculatePositions);
  }, [calculatePositions]);

  if (loading) {
    return <JustificationSuggestionsContainer loading={loading} />;
  }

  return (
    <div
      ref={setContainerRef}
      className={twMerge('relative w-full flex flex-col items-center mb-6', className)}
    >
      {/* Arrow */}
      <div className="relative w-full flex justify-center mb-6">
        <div
          className="absolute text-info-900"
          style={{ left: `${arrowPosition}px`, transform: 'translateX(-50%)' }}
        >
          <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg">
            <line x1="10" y1="10" x2="10" y2="17" stroke="currentColor" strokeWidth="3" />
            <polygon points="5,10 15,10 10,0" fill="currentColor" />
          </svg>
        </div>
      </div>
      {/* Suggestion sign */}
      <div
        ref={setCardRef}
        className="absolute"
        style={{
          left: `${cardPosition}px`,
          transform: 'translateX(-50%)',
          marginTop: '20px',
        }}
      >
        <div
          className="border border-neutral-300 rounded-lg px-2 py-1 flex flex-row items-center gap-2 bg-info-50"
          style={{ whiteSpace: 'nowrap' }}
        >
          <FontAwesomeIcon icon={faSparkles} className="text-info-900" />
          <p className="text-info-900">Archie's suggestion</p>
        </div>
      </div>
    </div>
  );
};

export default memo(SuggestionsMark);
